import React, { useEffect, useState, useRef, memo } from "react";
import CustomDate from "../../ui/customDate/CustomDate";
import CorporateActionDropDown from "./dropDowns/CorporateActionDropDown";
import CustomDate1 from "../../ui/customDate/CustomDate1";
import CaaStatusDropDownCell from "./dropDowns/CaaStatusDropDownCell";
import useSelectedFinYear from "../../../utils/selectedFinyear";
import useFetchFormatedData from "../../../utils/fetchDropdownData";
import MobileFilter from "../../ui/MobileFilter";
import ScriptDropDownCell from "./dropDowns/ScriptDropDownCell";
import ScripsDropDownCellTableData from "../../ui/dropDowns/ScripsDropDownCellTableData";

const getScripApi = `${process.env.REACT_APP_API_URL}api/get-script`;

const MasterDropDown = ({
  scriptNames,
  setFilterData,
  isFilter,
  setIsFilter,
  scrip,
  dataFetching,
}) => {
  let [value, setValue] = useState();
  let [selectedScriptName, setSelectedScriptName] = useState();
  const [handleSetValue, setHandleSetValue] = useState();
  const [selectedValues, setSelectedValues] = useState({});

  const {
    startFinDate,
    endFinDate,
    startFinYear,
    currentFinYear,
    currentDateStr,
  } = useSelectedFinYear();

  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  const { data: scriptData } = useFetchFormatedData(
    getScripApi,
    "GET",
    { headers },
    "script_name",
    "script_name",
  );

  const prevCorporateAction = useRef("");
  const prevCaa = useRef("");
  const prevExFrom = useRef("");
  const prevExTo = useRef("");

  console.log(
    "SESSION GET",
    sessionStorage.getItem("corporate_action"),
    " | ",
    sessionStorage.getItem("caa_status"),
  );

  useEffect(() => {
    // Initialize value from sessionStorage on first render
    const savedCorporateAction = sessionStorage.getItem("corporate_action");
    const savedCaa = sessionStorage.getItem("caa_status");
    const savedExFrom = sessionStorage.getItem("ex_from");
    const savedExTo = sessionStorage.getItem("ex_to");
    if (savedCorporateAction && savedCorporateAction !== "undefined") {
      setValue({ action: savedCorporateAction }); // Set initial value from sessionStorage
      setSelectedValues({ corporate_action: savedCorporateAction }); // Set initial value from sessionStorage
      prevCorporateAction.current = savedCorporateAction; // Initialize ref for comparison
    }

    if (savedCaa && savedCaa !== "undefined") {
      setValue({ caa_status: savedCaa }); // Set initial value from sessionStorage
      setSelectedValues({ caa_status: savedCaa }); // Set initial value from sessionStorage
      prevCaa.current = savedCaa; // Initialize ref for comparison
    }

    if (savedExFrom && savedExFrom !== "undefined") {
      setHandleSetValue({ ex_from: savedExFrom }); // Set initial value from sessionStorage
      setSelectedValues({ date_from: savedExFrom }); // Set initial value from sessionStorage
      prevExFrom.current = savedExFrom; // Initialize ref for comparison
    }

    if (savedExTo && savedExTo !== "undefined") {
      setHandleSetValue({ ex_to: savedExTo }); // Set initial value from sessionStorage
      setSelectedValues({ date_to: savedExTo }); // Set initial value from sessionStorage
      prevExTo.current = savedExTo; // Initialize ref for comparison
    }
  }, []);

  useEffect(() => {
    if (value || handleSetValue) {
      // Retrieve the current action and compare it to the previously stored one
      const storedCorporateAction =
        sessionStorage.getItem("corporate_action") || "";
      const storedCaa = sessionStorage.getItem("caa_status") || "";
      const storedExFrom = sessionStorage.getItem("ex_from") || "";
      const storedExTo = sessionStorage.getItem("ex_to") || "";
      const currentAction = (value?.action || "").trim();
      const currentScriptName = selectedScriptName;
      const currentCaa = (value?.caa_status || "").trim();
      const currentExFrom = (handleSetValue?.ex_from || "").trim();
      const currentExTo = (handleSetValue?.ex_to || "").trim();

      const obj = {
        corporate_action: currentAction,
        script_name: currentScriptName,
        caa_status: currentCaa,
        ex_from: currentExFrom,
        ex_to: currentExTo,
      };
      if (selectedScriptName && selectedScriptName !== "") {
        sessionStorage.setItem("CorporateActionMaster", 1);
      }
      if (
        currentAction === "" &&
        currentCaa !== "" &&
        currentExFrom !== "" &&
        currentExTo !== ""
      ) {
        sessionStorage.removeItem("corporate_action");
        console.log(
          "SESSION REMOVE::",
          storedCorporateAction,
          " | ",
          currentAction,
        );

        sessionStorage.setItem("CorporateActionMaster", 1);
      } else if (currentAction !== storedCorporateAction) {
        sessionStorage.setItem("CorporateActionMaster", 1);
        console.log(
          "SESSION SET::",
          storedCorporateAction,
          " | ",
          currentAction,
        );

        sessionStorage.setItem("corporate_action", currentAction);
        prevCorporateAction.current = currentAction;
      }
      if (
        currentCaa === "" &&
        currentAction !== "" &&
        currentExFrom !== "" &&
        currentExTo !== ""
      ) {
        sessionStorage.removeItem("caa_status");
        sessionStorage.setItem("CorporateActionMaster", 1);
      } else if (currentCaa !== storedCaa) {
        sessionStorage.setItem("CorporateActionMaster", 1);
        sessionStorage.setItem("caa_status", currentCaa);
        prevCaa.current = currentCaa;
      }

      if (
        currentCaa !== "" &&
        currentAction !== "" &&
        currentExFrom === "" &&
        currentExTo !== ""
      ) {
        sessionStorage.removeItem("ex_from");
        sessionStorage.setItem("CorporateActionMaster", 1);
      } else if (currentExFrom !== storedExFrom) {
        sessionStorage.setItem("CorporateActionMaster", 1);
        sessionStorage.setItem("ex_from", currentExFrom);
        prevExFrom.current = currentExFrom;
      }

      if (
        currentCaa !== "" &&
        currentAction !== "" &&
        currentExFrom !== "" &&
        currentExTo === ""
      ) {
        sessionStorage.removeItem("ex_to");
        sessionStorage.setItem("CorporateActionMaster", 1);
      } else if (currentExTo !== storedExTo) {
        sessionStorage.setItem("CorporateActionMaster", 1);
        sessionStorage.setItem("ex_to", currentExTo);
        prevExTo.current = currentExTo;
      }

      setFilterData(obj);
    }
  }, [value, handleSetValue, selectedScriptName, selectedValues]);

  const handleApplyFilters = (selectedValues) => {
    setFilterData({
      ...selectedValues,
      ex_from: selectedValues?.date_from,
      ex_to: selectedValues?.date_to,
    });

    if (selectedValues) {
      // Retrieve the current action and compare it to the previously stored one
      const storedCorporateAction =
        sessionStorage.getItem("corporate_action") || "";
      const storedCaa = sessionStorage.getItem("caa_status") || "";
      const storedExFrom = sessionStorage.getItem("ex_from") || "";
      const storedExTo = sessionStorage.getItem("ex_to") || "";
      const currentAction = (selectedValues?.corporate_action || "").trim();
      const currentScriptName = selectedScriptName;
      const currentCaa = (selectedValues?.caa_status || "").trim();
      const currentExFrom = (selectedValues?.date_from || "").trim();
      const currentExTo = (selectedValues?.date_to || "").trim();

      const obj = {
        corporate_action: currentAction,
        script_name: currentScriptName,
        caa_status: currentCaa,
        ex_from: currentExFrom,
        ex_to: currentExTo,
      };
      if (selectedScriptName && selectedScriptName !== "") {
        sessionStorage.setItem("CorporateActionMaster", 1);
      }
      if (
        currentAction === "" &&
        currentCaa !== "" &&
        currentExFrom !== "" &&
        currentExTo !== ""
      ) {
        sessionStorage.removeItem("corporate_action");
        sessionStorage.setItem("CorporateActionMaster", 1);
      } else if (currentAction !== storedCorporateAction) {
        sessionStorage.setItem("CorporateActionMaster", 1);
        sessionStorage.setItem("corporate_action", currentAction);
        prevCorporateAction.current = currentAction;
      }
      if (
        currentCaa === "" &&
        currentAction !== "" &&
        currentExFrom !== "" &&
        currentExTo !== ""
      ) {
        sessionStorage.removeItem("caa_status");
        sessionStorage.setItem("CorporateActionMaster", 1);
      } else if (currentCaa !== storedCaa) {
        sessionStorage.setItem("CorporateActionMaster", 1);
        sessionStorage.setItem("caa_status", currentCaa);
        prevCaa.current = currentCaa;
      }

      if (
        currentCaa !== "" &&
        currentAction !== "" &&
        currentExFrom === "" &&
        currentExTo !== ""
      ) {
        sessionStorage.removeItem("ex_from");
        sessionStorage.setItem("CorporateActionMaster", 1);
      } else if (currentExFrom !== storedExFrom) {
        sessionStorage.setItem("CorporateActionMaster", 1);
        sessionStorage.setItem("ex_from", currentExFrom);
        prevExFrom.current = currentExFrom;
      }

      if (
        currentCaa !== "" &&
        currentAction !== "" &&
        currentExFrom !== "" &&
        currentExTo === ""
      ) {
        sessionStorage.removeItem("ex_to");
        sessionStorage.setItem("CorporateActionMaster", 1);
      } else if (currentExTo !== storedExTo) {
        sessionStorage.setItem("CorporateActionMaster", 1);
        sessionStorage.setItem("ex_to", currentExTo);
        prevExTo.current = currentExTo;
      }

      setFilterData(obj);
    }
  };

  // filters.js
  const corpActionMasterFilters = [
    {
      name: "corporate_action",
      label: "Corporate Action",
      type: "select",
      options: [
        { value: "", label: " Select Corporate Action" },
        { value: "B", label: "Bonus" },
        { value: "S", label: "Split" },
        { value: "R", label: "Reduction" },
        { value: "C", label: "Consolidation" },
        { value: "A", label: "Merger" },
        { value: "X", label: "Demerger" },
        { value: "D", label: "Dividend" },
        { value: "G", label: "Right" },
      ],
    },
    {
      name: "script_name",
      label: "Scrip Name",
      type: "searchable",
      options: scriptData,
    },
    {
      name: "date_from",
      label: "Ex Date From",
      type: "date from",
    },
    {
      name: "date_to",
      label: "Ex Date To",
      type: "date to",
    },
    {
      name: "caa_status",
      label: "CAA Status",
      type: "select",
      options: [
        { value: "", label: "All" },
        { value: "S", label: "Auto Approved" },
        { value: "A", label: "Approved" },
        { value: "P", label: "Pending" },
        { value: "O", label: "Overdue" },
      ],
    },
  ];

  return (
    <div className=" relative flex items-baseline gap-2 pt-[10px]">
      <div className="mb-8 flex w-full flex-wrap items-baseline gap-4 max-sm:hidden ">
        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-full  flex-col gap-3 ">
            <label>Corporate Action</label>
            <CorporateActionDropDown
              value={value}
              setValue={setValue}
              className={"w-[200px]"}
              className1="py-[6px] [200px]"
            />
          </div>
        </div>

        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-3 ">
            <label>Scrip Name</label>
            <ScripsDropDownCellTableData
              dataFetching={dataFetching}
              scripData={scrip}
              setValue={setValue}
              setSelectedScriptName={setSelectedScriptName}
              page={"CA-MASTER"}
            />
          </div>
        </div>
        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-3 ">
            <label>Book Closure From Date</label>
            <CustomDate
              className={"w-[200px] bg-[#F7F7F7]"}
              initialValue={handleSetValue?.ex_from}
              setHandleSetValue={setHandleSetValue}
              min={startFinDate}
              max={
                handleSetValue?.ex_to
                  ? handleSetValue?.ex_to
                  : currentFinYear === startFinYear
                  ? currentDateStr
                  : endFinDate
              }
            />
          </div>
        </div>
        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-3 ">
            <label>Book Closure To Date</label>
            <CustomDate1
              className={"w-[200px] bg-[#F7F7F7]"}
              initialValue={handleSetValue?.ex_to}
              setHandleSetValue={setHandleSetValue}
              handleValue={handleSetValue}
              min={
                handleSetValue?.ex_from ? handleSetValue?.ex_from : startFinDate
              }
              max={
                currentFinYear === startFinYear ? currentDateStr : endFinDate
              }
            />
          </div>
        </div>
        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-3 ">
            <label>CAA Status</label>
            <CaaStatusDropDownCell
              className={"w-[200px] bg-[#F7F7F7]"}
              value={value}
              setValue={setValue}
            />
          </div>
        </div>
      </div>
      {isFilter && (
        <MobileFilter
          filters={corpActionMasterFilters}
          onApply={handleApplyFilters}
          onClose={() => setIsFilter(false)}
          isFilter={isFilter}
          setSelectedValues={setSelectedValues}
          selectedValues={selectedValues}
        />
      )}
    </div>
  );
};

export default memo(MasterDropDown);
